module.exports = __webpack_public_path__ + "img/badge-logo.7d82ebdb.svg";